export default import.meta.ROLLDOWN_FILE_URL_8Jdj9qQ4eJq3labUJOvRYQ